// LeakerBanWarning.jsx
// Print big warning in console
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { TranslationNamespace } from '../resource/translationNamespace.js';

const I18N_KEY = 'console_warning';
const FALLBACK_TEXT = // TODO: remote config
  '注意！任何嘗試外流操作將導致永久停權。\n\n' +
  '注意！任何尝试外流操作将导致永久停权。\n\n' +
  '警告！ コンテンツを記録または漏洩しようとすると、アカウントは永久に停止されます。\n\n' +
  "Avertissement! Toute tentative d'enregistrement ou de fuite de notre contenu entraînera la suspension permanente du compte.\n\n" +
  'Warnung! Der Versuch, unsere Inhalte aufzeichnen oder zu stehlen, führt zu einer dauerhaften Sperrung des Kontos.\n\n' +
  'Warning! Attempting to record or leak our contents will result in permanent account suspension.\n\n';

export class LeakerBanWarning extends React.PureComponent {
  componentDidMount() {
    const { t } = this.props;
    const i18nValue = t(I18N_KEY, {
      ns: TranslationNamespace.GENERAL,
    });
    const text = i18nValue !== I18N_KEY ? i18nValue : FALLBACK_TEXT;

    // eslint-disable-next-line no-console
    console.log(`%c${text}`, 'color: red; font-size: x-large');

    setTimeout(
      // eslint-disable-next-line no-console
      () => console.log(`%c${text}`, 'color: red; font-size: x-large'),
      3000 // TODO: remote config
    );
  }
  render() {
    return null;
  }
}

LeakerBanWarning.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LeakerBanWarning);
